import { render, staticRenderFns } from "./costOuter.vue?vue&type=template&id=3c2a73d7&scoped=true&"
import script from "./costOuter.vue?vue&type=script&lang=js&"
export * from "./costOuter.vue?vue&type=script&lang=js&"
import style0 from "./costOuter.vue?vue&type=style&index=0&id=3c2a73d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2a73d7",
  null
  
)

export default component.exports